export const blockIconsHardwareMemoryNew = (
	<span className='material-symbols-outlined'>memory</span>
);
